import * as React from "react";
import "@aurodesignsystem/auro-button";
import "@alaskaairux/auro-icon";
import "./Titlebar.scss";
import { useHistory, useLocation } from "react-router-dom";
import { AuthorizationAccessCheckAllEvents, AuthorizationAccessCheck } from "meportal/AuthorizationProvider";
import FilterModal from "../Modal/FilterModal";
import { EventTypeFilter } from "../../Models/EventTypeFilter";
import { AccessEditButton} from "../../constants/PermissionSet";
import { useSelector} from "react-redux";
import Alerts from "../Alerts/Alerts";
import RefreshStatus from '../OpenEvents/RefreshStatus';
import NewEventButton from "./NewEventButton/NewEventButton";
import ViewToggle from "../OpenEvents/ViewToggle";

interface TitleBarProps {
  title: string; 
  contextPath: string;
  otsAircraftCount: number;
  editClicked?: any;
  onApplyFilter?: any;
  filteredEventTypes?: EventTypeFilter[] | undefined;
  sortSelected?:any;
  eventType: string;
  alertNotificationCLicked?: (event: any) => void;
}

export default function TitleBar(props: TitleBarProps) {
  const aircraft = useSelector((state: any) => state.otsAircraft.otsAircraft);
  const history = useHistory();
  const location = useLocation();
  const [isDashboard, setIsDashboard] = React.useState(true);
  const [showEditButton, setShowEditButton] = React.useState(false);
  const [labelText, setLabelText] = React.useState(props.title ? props.title : "Live Events");
  const ArrowIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 1 18 17" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M7.26694 12.4687L7.20736 12.4173C7.01875 12.2287 7.00161 11.9335 7.15592 11.7256L7.20736 11.666L10.3731 8.49996L7.20736 5.33394C7.01875 5.14534 7.00161 4.8502 7.15592 4.64223L7.20736 4.58264C7.39596 4.39404 7.6911 4.37689 7.89907 4.5312L7.95866 4.58264L11.1247 7.74842L11.1691 7.79285C11.5596 8.18338 11.5596 8.81654 11.1691 9.20707L11.1247 9.2515L7.95866 12.4173C7.77005 12.6059 7.47492 12.623 7.26694 12.4687L7.20736 12.4173L7.26694 12.4687Z" fill="#0074cb" />
    </svg>
  );
  const getArrowIcon = () => <ArrowIcon />;
  const rootPath="/open-events";
  const previousLabelText=props.title ? props.title : "Live Events" + " ";
  const [showFilterModal, setShowFilterModal] = React.useState(false);
  const [eventsCount,setEventsCount] = React.useState<any>("All");

  const handleFilterButtonClick = () => {
    if(showFilterModal===true){
      setShowFilterModal(false);
    }else{
    setShowFilterModal(true);
  }
  };
  // const handleCreateButtonClick = () => {
  //   history.push(props.contextPath + "/create-ots");
  // };
  const clickBreadcrumb = () => { 
    history.push(rootPath)
  }

  const closeFilterModal = () => {
    setShowFilterModal(false);
  };

  const setTitlebarText = () => {

    if (location.pathname.indexOf("/edit-ots") > -1) {
      setLabelText("Event details");
      setShowEditButton(false);
      setIsDashboard(false);
    } else if (location.pathname.indexOf("/event-details") > -1) {
      setLabelText("Event details");
      setIsDashboard(false);
      setShowEditButton(true);
    } else {
      setLabelText(`${props.title} (${props.otsAircraftCount})`);
      setIsDashboard(true);
      setShowEditButton(false);
    }
  };

  React.useEffect(() => {
    setTitlebarText();
  }, [location.pathname, props.title, props.otsAircraftCount]);

  const handleAlertModalOpened = () => {
    if(showFilterModal){
      setShowFilterModal(false);
    }
  };
  
  const handleAlertNotificationCLicked = (event: any) => {
    if (props.alertNotificationCLicked) {
      props.alertNotificationCLicked(event);
    }
  };

    return (
        <div className="titlebar">
            <div className="titlebar-container" >
        {
          labelText == "Event details" ? (
            <a href={rootPath} className="lblcreatesize-breadcrumbs"
            onClick={(event) => {
              event.preventDefault(); // Prevent the default link behavior
              clickBreadcrumb(); // Call your custom function
            }}>
              {previousLabelText}
              <React.Fragment>{getArrowIcon()}</React.Fragment>
            </a>
          ) : ( "" )
        }
        <label className="lblotsevent lblunscheduledsize">&nbsp;{labelText}</label>
        <div>
          {/* {(isDashboard) && (
             <SyncStatus />
         )} */}
        </div>
        {isDashboard && <RefreshStatus/>
        }
        <div>
          {(isDashboard || showEditButton) && (
            <Alerts alertModalActive={handleAlertModalOpened} alertNotificationCLicked={handleAlertNotificationCLicked}/>
          )}
        </div>
       {isDashboard && (
           <ViewToggle />
       )}
        {
          isDashboard && (
            <div className="filter-button">
              <div className="">
                <auro-button
                  variant="secondary"
                  fluid
                  onClick={handleFilterButtonClick}
                  data-testid="filter-button">
                    <span className="sort-modal-btn">
                      <svg className="filter-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path fillRule="evenodd" clipRule="evenodd" d="M9.75129 12.7329L4.38326 4.9249C4.04114 4.42727 4.3974 3.75 5.00129 3.75H19.0013C19.6052 3.75 19.9614 4.42727 19.6193 4.9249L14.2513 12.7329V18C14.2513 18.2841 14.0908 18.5438 13.8367 18.6708L10.8367 20.1708C10.338 20.4202 9.75129 20.0575 9.75129 19.5V12.7329ZM17.5755 5.25H6.42706L11.1193 12.0751C11.2053 12.2001 11.2513 12.3483 11.2513 12.5V18.2865L12.7513 17.5365V12.5C12.7513 12.3483 12.7973 12.2001 12.8833 12.0751L17.5755 5.25Z" fill="#0074C8" />
                    </svg> 
                    <span className="sort-modal-title"> Sort & filter ({eventsCount})</span>
                   </span>
                </auro-button>
              </div>
                  <div className="relative-container">
                    <FilterModal isModalOpen={showFilterModal} close={closeFilterModal} onApplyFilter={props.onApplyFilter} filteredEventTypes={props.filteredEventTypes} sortSelected={props.sortSelected} onCheckedCount={(value: any) => setEventsCount(value)} />
                  </div>
            </div>
          )
        }
        {isDashboard && (
          <AuthorizationAccessCheckAllEvents permission="Create event button">
          <div className="fullWidth plus">
            <NewEventButton onEventCreate={(eventType: string) => console.log(eventType)} contextPath={props.contextPath} />
            {/* <auro-button
              variant="primary"
              fluid
              onClick={handleCreateButtonClick}
              data-testid="plus-btn">
              <span className="btnlabel-white edit-button"><svg className="plus-sign" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<path fillRule="evenodd" clipRule="evenodd" d="M11.8982 7.00685L12 7C12.3797 7 12.6935 7.28215 12.7432 7.64823L12.75 7.75V11.25H16.25C16.6297 11.25 16.9435 11.5322 16.9932 11.8982L17 12C17 12.3797 16.7178 12.6935 16.3518 12.7432L16.25 12.75H12.749L12.75 16.25C12.75 16.6297 12.4678 16.9435 12.1018 16.9932L12 17C11.6203 17 11.3065 16.7178 11.2568 16.3518L11.25 16.25L11.249 12.75H7.75C7.3703 12.75 7.05651 12.4678 7.00685 12.1018L7 12C7 11.6203 7.28215 11.3065 7.64823 11.2568L7.75 11.25H11.25V7.75C11.25 7.3703 11.5322 7.05651 11.8982 7.00685L12 7L11.8982 7.00685Z" fill="white"/>
</svg> New event</span>
            </auro-button> */}
          </div>
          </AuthorizationAccessCheckAllEvents>
        )}
        {
          showEditButton && (
            <div className="fullWidth">
              <AuthorizationAccessCheck eventId={aircraft?.Airline + ":" + aircraft?.EventType} permission={AccessEditButton} returnBoolean={false}>
                <auro-button
                  variant="primary"
                  fluid
                  onClick={() => props.editClicked(true)}
                >
                  <span className="btnlabel-white edit-button">Edit</span>
                </auro-button>
              </AuthorizationAccessCheck>
            </div>
          )
              }
      </div >
    </div>
  );
}
